import { REGEX_EMAIL } from "../../constants/Regex"

export interface emailInvoice {
  email: string
}

interface ValidationErrors {
  [key: string]: string
}

export const validateSend = (input: emailInvoice, chips: Array<string>): ValidationErrors => {
  const errors: ValidationErrors = {}
  if (!chips.length && !input.email) errors.email = 'Correo electrónico es requerido'
  if (!errors.email) (input.email && !REGEX_EMAIL.test(input.email.trim())) && (errors.email = 'Correo electrónico inválido')
  return errors
}

export const validateSendOnBlur = (
  input: emailInvoice,
  name: string,
  errors: any,
  chips: Array<string>,
): emailInvoice => {
  switch (name) {
    case 'email':
      if (!chips.length && !input.email.trim()) errors.email = 'Correo electrónico es requerido'
      else if (input.email && !REGEX_EMAIL.test(input.email.trim())) errors.email = 'Correo electrónico inválido'
      else errors.email = ''
      break
    default:
      break
  }
  return errors
}
